var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-count pa-2 white rounded-lg",class:{
    'card-fluid': _vm.fluid,
    'card-active': _vm.cardActive,
    'cursor-pointer': _vm.canClick,
    hoverable: _vm.canClick,
    'shadow-lg': _vm.shadowLg,
  },on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',[_c('v-icon',{staticClass:"pa-2 rounded-circle mx-2 icon",attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1),_c('div',{staticClass:"body"},[_c('div',{staticClass:"text--secondary"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.value))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }